import React, { useEffect, useState } from "react";
import "./HomePages.css";
import { Link } from "react-router-dom";
import { doc, onSnapshot } from "firebase/firestore";
import { auth } from "../firebase/auth";
import { db } from "../firebase/firestore";
import { useCurrentUser } from "../components/useCurrentUser";
import { Countdown } from "../components/Countdown";
// import heroImage from "../assets/images/portrett_paa_fjell.jpeg";
import heroImage from "../assets/images/portrett_solastrand.jpg";
import heroImageAvslutning from "../assets/images/posering_i_par.jpeg";

const English: React.FC = () => {
const { displayName } = useCurrentUser();

  return (
    <div className="home-page">
      <section
        className="hero-section"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <div className="hero-overlay">
          <div className="hero-text">
            <h1>30 05 26</h1>
            <p>MARTHE ELISE & OSCAR</p>
            {/* <p><Countdown targetDate="2026-05-30T12:00:00Z" /></p> */}
          </div>
        </div>
      </section>
      {/* BRUDEPARETS HJØRNE */}
      {/* BRUDEPARETS HJØRNE */}
      {/* BRUDEPARETS HJØRNE */}
      {/* BRUDEPARETS HJØRNE */}
      {/* BRUDEPARETS HJØRNE */}
      {/* BRUDEPARETS HJØRNE */}
      {/* BRUDEPARETS HJØRNE */}
      {/* BRUDEPARETS HJØRNE */}
      <section className="info-section">
        <div className="info-box">
          <h2>Welcome!</h2>
          <p>Hi! We are so glad that you want to come celebrate this day with us {displayName}! Please let us know if you have any questions. Marthe Elise +47 928 64 234 / Oscar +47 481 72 166</p>
            <ul>
              <p><b>Last update May 27th</b></p>
              <li>1st March: Gift lists added.</li>
              <li>4th May: Updated times added.</li>
              <li>27th May: Updated times added.</li>
            </ul>
        </div>

      </section>
      {/* REGISTRATION */}
      {/* REGISTRATION */}
      {/* REGISTRATION */}
      {/* REGISTRATION */}
      {/* REGISTRATION */}
      {/* REGISTRATION */}
      {/* REGISTRATION */}
      {/* REGISTRATION */}
      <section className="info-section">
        <div className="info-box">
          <h2>Important dates for registration</h2>
          <ul>
            <li>
              <p><b>Allergies</b>: Please let the bride or groom know before April 1st.</p>
            </li>
            <li>
              <p><b>Transport from the church</b>: Please let the bride or groom know before April 1st.</p>
            </li>
            <li>
              <p><b>Friday meet & greet</b>: Please let the bride or groom know before April 26th.</p>
            </li>
            <li>
              <p><b>Speeches</b>: Please let the bride or groom know before April 26th. We request the speeches to be limited to 4 minutes.</p>
              {/* Please let the toastmasters know before 26th of April. Toastmasters are Rikke & Kjell Ivar Smedbøl, +47 480 90 614 / +47 922 20 477. The wedding couple request the speeches to be limited to 4 minutes. */}
            </li>
          </ul>
        </div>
        {/* GENERAL INFORMATION */}
        {/* GENERAL INFORMATION */}
        {/* GENERAL INFORMATION */}
        {/* GENERAL INFORMATION */}
        {/* GENERAL INFORMATION */}
        {/* GENERAL INFORMATION */}
        {/* GENERAL INFORMATION */}
        {/* GENERAL INFORMATION */}
        <div className="info-box">
          <h2>General information</h2>
          <p>The wedding ceremony will be in <a href="https://www.visitnorway.no/listings/stavanger-domkirke/14665/">Stavanger Cathedral</a>, and the celebration will be held at <a href="https://www.solastrandhotel.no">Sola Strand Hotell</a>. We will arrange transportation by bus from the church to the hotel, for the ones who require.</p>
          <ul>
            <li>
              <p><b>Discounts (Hotel)</b>: Sola Strand Hotell offer a 20% discount on bookings. To use the discount you have to either make the booking by phone and mention the occation, or postpone the payment until the check in and ask for the discount at the frontdesk.</p>
            </li>
            <li>
              <p><b>Parking</b>: Parking at the hotel is administrered by a company called <a href="https://onepark.no/autopay/">OnePark</a>. The parking is managed through the apps "Autopay" or "Easypark".</p>
            </li>
            <li>
              <p><b>Pictures</b>: A photographer will cover the day until the dinner seating. If you take any photos throughout the day, especially from the seating and later, we would appreciate if you can share those with us afterwards. A friendly reminder to not share any pictures on social media, unless you have concent by the people in the picture.</p>
            </li>
          </ul>
        </div>
        {/* SENDESKJEMA */}
        {/* SENDESKJEMA */}
        {/* SENDESKJEMA */}
        {/* SENDESKJEMA */}
        {/* SENDESKJEMA */}
        {/* SENDESKJEMA */}
        {/* SENDESKJEMA */}
        {/* SENDESKJEMA */}
        <div className="info-box">
          <h2>Time schedule</h2>
          <p><b>Friday May 29th<br />
                summer attire</b></p>
          <ul>
            <li><b>18:00</b>: Unformal meet & greet with simple serving at the recident of the Bride`s parents, for those willing and able. <br /> Address is Ragnhildsgate 72, 4044 Hafrsfjord.</li>
          </ul>
          <br />
          <p><b>Saturday May 30th <br />
                Tuxedo / Dark suit / Dress.</b></p>
          <ul>
            <li><b>12:30</b>: Church doors open.</li>
            <li><b>13:00</b>: Wedding ceremony start.</li>
            <li><b>14:00</b>: Transport to Sola Strand hotel. Buss arrive at "Kongsgård skole", the buss stop out the church then to the left</li>
            <li><b>14:45</b>: Some finger food and drinks at the hotel (Axel Lunds Stue), while we run through the photoshoot.</li>
            <li><b>18:00</b>: Seating.</li>
            <li><b>22:00</b>: Cake and Coffee.</li>
            <li><b>23:30</b>: Night food to keep the party going.</li>
            <li><b>02:00</b>: Party must stop or movie to a different location</li>
          </ul>
        </div>
        {/* GAVELISTE */}
        {/* GAVELISTE */}
        {/* GAVELISTE */}
        {/* GAVELISTE */}
        {/* GAVELISTE */}
        {/* GAVELISTE */}
        {/* GAVELISTE */}
        {/* GAVELISTE */}
        <div className="info-box">
          <h2>Gift lists</h2>
          <p>They may be updated with additional wishes later.</p>
          <ul>
            <li><a href="https://www.illumsbolighus.no/onskeliste/andre?id=d80c9ed3712aebcc9468a17258">Illums Bolighus</a>.</li>
            <li><a href="https://www.cg.no/apps/giftregistry/registry/415918?_r=1&utm_source=gift_reggie&utm_medium=gift_reggie&utm_campaign=gift_reggie&utm_content=415918">Christiania Glassmagasin</a>.</li>
            <li><a href="https://www.kitchn.no/onskeliste/245419/">Kitch`n</a>.</li>
            <li><a href="https://www.designforevig.no/bryllupslister/675088">Brødrene Pedersen.</a></li>
          </ul>
        </div>
        {/* TRIVIA */}{/* ENGLISH */}
        {/* TRIVIA */}{/* ENGLISH */}
        {/* TRIVIA */}{/* ENGLISH */}
        {/* TRIVIA */}{/* ENGLISH */}
        {/* TRIVIA */}{/* ENGLISH */}
        {/* TRIVIA */}{/* ENGLISH */}
        {/* TRIVIA */}{/* ENGLISH */}
        {/* TRIVIA */}{/* ENGLISH */}
        {/* <div className="info-box">
          <h2>Trivia</h2>
          <ul>
            <li><b>Kirken</b>: text .....................</li>
            <li><b>Prekerstolen</b>: text .....................</li>
            <li><b>Sola Airshow</b>: text .....................</li>
            <li><b>Stavanger by</b>: text .....................</li>

          </ul>
        </div> */}
        {/* AVSLUTTENDE BILDE */}
        {/* AVSLUTTENDE BILDE */}
        {/* AVSLUTTENDE BILDE */}
        {/* AVSLUTTENDE BILDE */}
        <div className="info-box">
          <section
            className="hero-section"
            style={{ backgroundImage: `url(${heroImageAvslutning})` }}
          >
          </section>
        </div>
      </section>

      <footer>
        {/* AVSLUTTENDE TEXT */}
        {/* AVSLUTTENDE TEXT */}
        {/* AVSLUTTENDE TEXT */}
        {/* AVSLUTTENDE TEXT */}
        <section
          className="hero-section"
          // style={{ backgroundImage: `url(${heroImageAvslutning})` }}
          style={{ backgroundColor: "black" }}
        >
          <div className="hero-overlay">
            <div className="hero-text">
              <p><Countdown targetDate="2026-05-30T12:00:00Z" /></p>
              <p>...and the bride march down the aisle 🥂🥂</p>
            </div>
          </div>
        </section>
      </footer>
    </div>
  );
};

export default English;
